import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchBags = createAction(ACTION.FETCH_BAGS.REQUEST, (params) => params);
export const onReset = createAction(ACTION.RESET_LIST_BAG, () => {
});
export const exportBagCsv = createAction(ACTION.EXPORT_BAGS_CSV.REQUEST, (params) => params);
export const onSwitchTab = createAction(ACTION.SWITCH_TAB, () => {
});
